import React, { useState, useEffect, useRef } from 'react';
import { hasAccess, useHasAccess } from 'cp-client-auth!sofe';
import { CprIcon } from 'canopy-styleguide!sofe';

export const ContactNameDropdown = props => {
  const [show, setShow] = useState(false);
  const canEdit = useHasAccess('contacts_create_edit')
  const canArchive = useHasAccess('contacts_archive')
  const canDelete = useHasAccess('contacts_delete')

  const dropdownToggle = useRef();

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleClickOutside = e => {
    if (dropdownToggle && !dropdownToggle.current.contains(e.target)) {
      setShow(false);
    }
  };

  return (
    <div id="contactNameDropdown" className={`cps-dropdown cps-pull-left cps-margin-left-8 ${show ? 'cps-open' : ''}`}>
      <div ref={dropdownToggle} className="cps-btn-icon">
        <a className="cps-link cps-margin-top-0" onClick={() => setShow(!show)}>
          <span className="cps-icon cps-icon-down-caret" />
        </a>
      </div>
      <ul className="cps-dropdown-menu" role="menu">
        {canEdit && <li>
          <a onClick={props.showContactEditModal}>
            <CprIcon name="edit" className="cps-icon cps-dropdown-menu__icon" />
            Edit
          </a>
        </li>}
        {canArchive && <li>
          <a onClick={props.archiveContact}>
            <CprIcon name="archive" className="cps-icon cps-dropdown-menu__icon" />
            Archive
          </a>
        </li>}
        {canDelete && (
          <li>
            <a onClick={props.showDeleteModal}>
              <CprIcon name="trash" className="cps-icon cps-dropdown-menu__icon" />
              Delete
            </a>
          </li>
        )}
      </ul>
    </div>
  );
};
